import CollectionList from './collection-list';

export default CollectionList;